export const centrado = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
